import { State } from "..";

export const getCreatedSystemId = (state: State) =>
	state.createSystem.create?.success;
export const getCreateReqInfo = (state: State) => state.createSystem.create;
export const getUpdatedSystemId = (state: State) =>
	state.createSystem.update?.success;
export const getUpdateReqInfo = (state: State) => state.createSystem.update;
export const getSystem = (state: State) => state.createSystem.get?.success;
export const getSystemReqInfo = (state: State) => state.createSystem.get;
export const getCurrentFormReqInfo = (state: State) =>
	state.createSystem.currentForm;
export const getCurrentForm = (state: State) =>
	state.createSystem.currentForm.success;
export const getFormResult = (state: State) =>
	state.createSystem.getFormResult?.success;
export const getFormResultReqInfo = (state: State) =>
	state.createSystem.getFormResult;
export const getSubmitFormResult = (state: State) =>
	state.createSystem.submitFormResult.success?._evaluationResult;
export const getSubmitFormFlags = (state: State) =>
	state.createSystem.submitFormResult.success?._flags;
export const getSubmitFormFields = (state: State) =>
	state.createSystem.submitFormResult.success?._fields;
export const getSubmitFormResultReqInfo = (state: State) =>
	state.createSystem.submitFormResult;
